import { AdminForm } from 'alto-react-components/lib/components'
import { Client    } from 'alto-react-kredit/lib/models'

statusOptions = { 'aktivní': 'A', 'neaktivní': 'N' }
sexOptions    = { 'muž': 'M', 'žena': 'F' }

class ClientForm extends AdminForm
  model: Client

  @defaultValues:
    firstname: ''
    surname:   ''
    email:     ''
    clientId:  ''
    cardId:    ''
    status:    'A'
    comment:   ''
    personal:
      sex: 'M'
      birthDate: null
      phone: null
      phone2: null
    address:
      country:     'ČR'
      city:        ''
      areaCode:    ''
      street:      ''
      houseNumber: ''
    company:
      name: ''
      ico:  ''
      dic:  ''

  @inputs: [{
    label:     'Jméno'
    property:  'firstname'
  }, {
    label:     'Příjmení'
    property:  'surname'
  }, {
    type:      'email'
    label:     'Email'
    property:  'email'
  }, {
    label:     'ID klienta'
    property:  'clientId'
    validator: 'notEmpty'
  }, {
    label:     'ID karty'
    property:  'cardId'
    validator: 'notEmpty'
  }, {
    label:     'ID čipové karty'
    property:  'chipId'
  }, {
    type:      'select'
    label:     'Status'
    property:  'status'
    options:   statusOptions
  }, {
    label:    'Komentář'
    property: 'comment',
  }, {
    type:     'checkbox'
    label:    'Zasílat novinky',
    property: 'news',
  }, {
    type:     'checkbox'
    label:    'Zasílat denní menu',
    property: 'dailyMenu',
  }, {
    group: true
    name:  'personal'
    label: 'Osobní'
    inputs: [{
      type:      'select'
      label:     'Pohlaví'
      options:   sexOptions
      property:  'personal.sex'
    }, {
      type:      'date'
      label:     'Datum narození'
      property:  'personal.birthDate'
    }, {
      label:     'Telefon'
      validator: 'phone'
      property:  'personal.phone'
    }, {
      label:     'Telefon 2'
      validator: 'phone'
      property:  'personal.phone2'
    }]
  }, {
    group: true
    name:  'address'
    label: 'Adresa'
    collapsed: true
    inputs: [{
      label:    'Stát'
      property: 'address.country',
    }, {
      label:    'Město'
      property: 'address.city',
    }, {
      label:    'PSČ'
      property: 'address.areaCode',
    }, {
      label:    'Ulice'
      property: 'address.street',
    }, {
      label:    'Číslo popisné'
      property: 'address.houseNumber',
    }]
  }, {
    group: true
    name:  'company'
    label: 'Firma'
    collapsed: true
    inputs: [{
      label:    'Jméno firmy'
      property: 'company.name',
    }, {
      label:    'IČO'
      property: 'company.ico',
    }, {
      label:    'DIČ'
      property: 'company.dic',
    }]
  }]

  defaultValues: @defaultValues
  inputs:        @inputs

export default ClientForm
